import { useEffect, useRef } from 'react';

// Changing a filter or the appearance flag keeps the current reading position.
// Only a new page in the refined workspace starts at its heading.
export default function useRefinedRouteScrollReset(pathname, enabled) {
  const previousPathname = useRef(pathname);

  useEffect(() => {
    const pageChanged = previousPathname.current !== pathname;
    previousPathname.current = pathname;
    if (pageChanged && enabled) window.scrollTo(0, 0);
  }, [pathname, enabled]);
}
